/**
 * Run something when the document is ready. If the behaviour was loaded via script[type=module] or script[defer] then
 * it will be ready immediately. Otherwise, we can use DOMContentLoaded.
 *
 * @returns {Promise<unknown>}
 */
export function whenReady() {
	return new Promise((resolve, reject) => {
		// If the document is already interactive, resolve immediately.
		if (['interactive', 'ready'].indexOf(document.readyState) > -1) {
			resolve();

			return;
		}

		document.addEventListener('DOMContentLoaded', resolve);
	});
}


